var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "coupon-show"
  }, [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : _c('div', {
    staticClass: "coupon-show__panel"
  }, [_c('div', {
    staticClass: "coupon_close",
    on: {
      "click": _vm.redirectToOa
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "32",
      "d": "M368 368L144 144M368 144L144 368"
    }
  })])]), _vm.coupon ? _c('coupon', {
    attrs: {
      "coupon": _vm.coupon
    },
    on: {
      "confirmed": _vm.setUsed
    }
  }) : _vm.redeemCodeBundleId ? _c('temp-coupon', {
    attrs: {
      "redeem-code-bundle-id": _vm.redeemCodeBundleId
    },
    on: {
      "redeemed": _vm.redeemed
    }
  }) : _c('coupon-empty')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }